import type { ComponentChildren } from 'preact';
import cn from 'classnames';
import styles from './Accordion.module.scss';

export type AccordionProps = {
  /** List of accordion items */
  children: ComponentChildren;
  className?: string;
  size?: 'small' | 'medium';
};

export default function Accordion({
  children,
  className,
  size
}: AccordionProps) {
  return (
    <div
      class={cn(
        { [styles.small]: size === 'small' },
        styles.container,
        className
      )}
    >
      <div class={styles.items}>{children}</div>
    </div>
  );
}

export type AccordionItemProps = {
  title: ComponentChildren | string;
  children: ComponentChildren;
  name?: string;
  className?: string;
  isOpen?: boolean;
  onToggle?: () => void;
};

function AccordionItem({
  title,
  children,
  name,
  onToggle,
  className,
  isOpen
}: AccordionItemProps) {
  return (
    <details
      name={name}
      class={cn(styles.details, className)}
      onToggle={onToggle}
      open={isOpen}
    >
      <summary class={styles.summary}>{title}</summary>
      <div class={styles.contents}>{children}</div>
    </details>
  );
}

Accordion.Item = AccordionItem;
